import styled from "styled-components"
import { Dropdown, DropdownItem } from 'reactstrap'

export const HoverDropdown = styled(Dropdown)`
    .dropdown-toggle.btn.btn-secondary {
		box-shadow: none !important;
		background: inherit;
		padding: 0;
	}

	.dropdown-toggle::after {
		display: none !important;
	}
`

export const HoverDropdownItem = styled(DropdownItem)`
	color: inherit !important;
	padding: 6px 12px !important;
	margin: 0 !important;
`


// WEBPACK FOOTER //
// ./src/components/Catalog/styled.js